<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar-nav>
          <b-button @click="previousPage" size="sm" variant="light">
            <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon
            >Back
          </b-button>
        </b-navbar-nav>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Client Details</b-navbar-brand>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <b-container fluid>
              <!-- User Interface controls -->
              <b-row class="gutr">
                <b-col md="12" class="my-1">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input
                        :formatter="capitalizeAll"
                        v-model="filter"
                        placeholder="Type To Search"
                      />
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''"
                          >Clear</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- Main table element -->
              <b-table
                show-empty
                stacked="md"
                :items="clientListView"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                @filtered="onFiltered"
              >
                <template slot="clientId" slot-scope="row0">
                  <span>{{
                    row0.index + 1 + (currentPage - 1) * perPage
                  }}</span>
                </template>
                <template slot="clientName" slot-scope="row11">
                  <div
                    :style="row11.item.isKYC != 'Yes' ? 'color:red' : ''"
                    @click="viewClientpage(row11.item.clientId)"
                    class="showMoreData"
                  >
                    <span>{{ row11.item.clientName }}</span>
                    <br />
                    <h6>
                      <b-badge v-if="row11.item.isKYC != 'Yes'" variant="danger"
                        >Kyc Not Done</b-badge
                      >
                    </h6>
                  </div>
                </template>
                <template slot="segment" slot-scope="row5">
                  <div v-if="row5.item.segment != null">
                    <div v-if="row5.item.segment != null">
                      <span
                        v-for="(item1, index) in row5.item.segment.split(',')"
                        :key="index"
                      >
                        <h6>
                          <b-badge variant="light">{{
                            item1 == "" ? "-------" : item1
                          }}</b-badge>
                        </h6>
                      </span>
                    </div>
                  </div>
                </template>
                <template slot="companyType" slot-scope="row11">
                  <span>Company Type : {{ row11.item.companyType }}</span>
                  <br />

                  <span>
                    Corporate Address : {{ row11.item.corporateAddress }}
                    <br />
                    {{ row11.item.stateName }}
                  </span>
                </template>
                <template slot="phoneKYC" slot-scope="row1">
                  <span>Contact No. : {{ row1.item.phoneKYC }}</span>
                  <br />
                  <span>Email-Address : {{ row1.item.email }}</span>
                  <br />
                  <span>Alternate Email-Addr : {{ row1.item.altMail }}</span>
                </template>
              </b-table>

              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-0 pull-right"
                  />
                </b-col>
              </b-row>
            </b-container>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose"
      ref="addPop"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import DatePicker from "vue2-datepicker";

import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";

export default {
  beforeMount() {
    this.$store.dispatch("setCurrentRoute", "/dashboard");
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != "" &&
      this.$sessionsStorage.get("departmentName") != undefined &&
      this.$sessionsStorage.get("departmentName") != "" &&
      this.$sessionsStorage.get("designation") != undefined &&
      this.$sessionsStorage.get("designation") != ""
    ) {
      this.getData();
    } else {
      this.$sessionsStorage.set("loginId", "");
      this.$router.push({
        path: "/Login/",
      });
    }
  },

  data() {
    return {
      fields: [
        {
          key: "clientId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "clientName",
          label: "Client Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "segment",
          label: "Business Type",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "companyType",
          label: "Company Type",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "clientFactoryLoc",
          label: "Factory Location",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "phoneKYC",
          label: "Contact Detail",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },
      isLoading: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      clientId: "",
      clientListView: [],
      excelUpload: "",
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    ModelListSelect,
    // Loading
    CustomLoader,
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },

  methods: {
    previousPage() {
      window.history.go(-1);
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    doLoading() {
      this.isLoading = true;
      // simulate AJAX
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    JqueryFun() {
      return $(function () {
        return $("#viewSalesBooking").DataTable();
      });
    },

    onClose(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "clientdetail",
          tableIsActive: "clientIsActive",
          tableId: "clientId",
          tableVal: this.clientId,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deleteData.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.getData();

              // console.log(data);
            }
          })
          .catch((error) => {});
      } else {
        this.getData();
      }
    },

    deleteClient(clientID) {
      this.clientId = clientID;
      this.$refs["addPop"].open();
    },

    viewClientpage(clientID) {
      this.$router.push({
        path: "/dashboard/specificClientReports/" + clientID,
      });
      //   this.$sessionsStorage.set("editClientId", clientID);
      //   this.$router.push({
      //     path: "/client/addClient"
      //   });
    },

    getData() {
      this.doLoading();
      let client_detail = {
        Client_Profile: "Client_Profile",
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_EmpDashboard/getDataClientProfileReports.php`,
        data: JSON.stringify(client_detail),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);
            this.clientListView = data.allclient;
            this.totalRows = data.allclient.length;
            this.doLoadingClose();
          }
        })
        .catch((error) => {});
    },
    downloadExcel() {
      let excelName = {
        excelName: "ClientMaster",
        validExcel: "yes",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/downloadMasterExcel.php`,
        data: JSON.stringify(excelName),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            // console.log(data);
            // console.log(data.link12);

            window.open(data.link12);
          }
        })
        .catch((error) => {});
    },
    onFileChange() {
      var files = event.target.files || event.dataTransfer.files;
      // this.uploadCheck = files[0];
      var formData = new FormData();

      for (let i = 0; i < files.length; i++) {
        formData.append(`clientMaster[]`, files[i]);
      }
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(`${URL_BASE}/uploadExcelDataMaster.php`, formData, config)
        .then((result) => {
          console.log(result.data);
          if (result.data == "Only XLXS Format Support") {
            this.alert.content = "Only .xlxs format support";
          } else {
            this.alert.content = result.data;
          }
          this.$refs["addPop"].open();
          this.getData();
        })
        .catch((err) => {
          throw err;
        });
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// clientProfile_reports.vue?29bec481